module.exports = __webpack_public_path__ + "od-chevron-right-white/od-chevron-right-white-2ef6e2fe1aa641792b1d64eefb81f482.svg";